import { SortingState } from '@tanstack/react-table';
import { TransactionType } from '@repo/common-types';
import { TransactionFilterDto } from '@/services/transactions/transactions-types';

export enum TransactionsActionType {
  SET_FILTERS = 'SET_FILTERS',
  SET_SEARCH = 'SET_SEARCH',
  SET_TX_ID = 'SET_TX_ID',
  SET_USER_ALIAS = 'SET_USER_ALIAS',
  SET_TABLE_NAME = 'SET_TABLE_NAME',
  SET_STATUS = 'SET_STATUS',
  SET_TYPE = 'SET_TYPE',
  SET_PAGINATION = 'SET_PAGINATION',
  SET_SORTING = 'SET_SORTING',
  RESET_FILTERS = 'RESET_FILTERS',
  SET_DATE_RANGE = 'SET_DATE_RANGE',
}

export type TransactionsAction =
  | { type: TransactionsActionType.SET_FILTERS; payload: TransactionFilterDto }
  | { type: TransactionsActionType.SET_SEARCH; payload: string }
  | { type: TransactionsActionType.SET_TX_ID; payload: number }
  | { type: TransactionsActionType.SET_USER_ALIAS; payload: string }
  | { type: TransactionsActionType.SET_TABLE_NAME; payload: string }
  | { type: TransactionsActionType.SET_STATUS; payload: string }
  | { type: TransactionsActionType.SET_TYPE; payload: TransactionType }
  | { type: TransactionsActionType.SET_PAGINATION; payload: { skip: number; take: number } }
  | { type: TransactionsActionType.SET_SORTING; payload: SortingState }
  | { type: TransactionsActionType.RESET_FILTERS }
  | { type: TransactionsActionType.SET_DATE_RANGE; payload: { fromDate: Date; toDate: Date } };

export interface TransactionsQueryState {
  filter: TransactionFilterDto;
  skip: number;
  take: number;
  sorting: SortingState;
}

export const initialFilters: TransactionFilterDto = {
  search: undefined,
  txId: undefined,
  userAlias: undefined,
  tableName: undefined,
  status: undefined,
  type: undefined,
  toDate: undefined,
  fromDate: undefined,
};

export const initialState: TransactionsQueryState = {
  filter: initialFilters,
  skip: 0,
  take: 25,
  sorting: [
    {
      id: 'createdAt',
      desc: true,
    },
  ],
};

export const transactionsQueryReducer = (
  state: TransactionsQueryState,
  action: TransactionsAction,
): TransactionsQueryState => {
  switch (action.type) {
    case TransactionsActionType.SET_FILTERS:
      return {
        ...state,
        filter: action.payload,
        skip: 0,
      };
    case TransactionsActionType.SET_SEARCH:
      return {
        ...state,
        filter: { ...state.filter, search: action.payload },
        skip: 0,
      };
    case TransactionsActionType.SET_TX_ID:
      return {
        ...state,
        filter: { ...state.filter, txId: action.payload },
        skip: 0,
      };
    case TransactionsActionType.SET_USER_ALIAS:
      return {
        ...state,
        filter: { ...state.filter, userAlias: action.payload },
        skip: 0,
      };
    case TransactionsActionType.SET_TABLE_NAME:
      return {
        ...state,
        filter: { ...state.filter, tableName: action.payload },
        skip: 0,
      };
    case TransactionsActionType.SET_STATUS:
      return {
        ...state,
        filter: { ...state.filter, status: action.payload },
        skip: 0,
      };
    case TransactionsActionType.SET_TYPE:
      return {
        ...state,
        filter: { ...state.filter, type: action.payload },
        skip: 0,
      };
    case TransactionsActionType.SET_PAGINATION:
      return {
        ...state,
        skip: action.payload.skip,
        take: action.payload.take,
      };
    case TransactionsActionType.SET_SORTING:
      return {
        ...state,
        sorting: action.payload,
        skip: 0,
      };
    case TransactionsActionType.SET_DATE_RANGE:
      return {
        ...state,
        filter: { ...state.filter, fromDate: action.payload.fromDate, toDate: action.payload.toDate },
        skip: 0,
      };
    case TransactionsActionType.RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
};
